module.exports = __webpack_public_path__ + "static/index/img/baikal-707.ae547aa4.jpg";